import React, { Fragment } from 'react';
import { Search, SearchInput, SearchResult, SearchResultList, SearchResultItem, SvgIcon, } from 'seduo-ui';
const Example = () => (<Search isFocused={true}>
        <SearchInput value="Test" onChange={() => undefined} onToggle={() => undefined} onKeyDown={() => undefined}/>
        <SearchResult isOpen={true}>
            <span className="search__section-headline">Category</span>
            <SearchResultList>
                <SearchResultItem isActive={true} title="Test Category" subTitle="Interesting description" href="#" rightColumn={<Fragment>5 kurzů</Fragment>} onMouseDown={() => undefined} highlightValue={'Test'}>
                    <SvgIcon kind="Categories" className="search-list__icon"/>
                </SearchResultItem>
                <SearchResultItem isActive={false} title="Test Category 2" subTitle="I am not going to give a lengthy description of what is in this category." href="#" rightColumn={<Fragment>5 kurzů</Fragment>} onMouseDown={() => undefined} highlightValue={'Test'}>
                    <SvgIcon kind="Categories" className="search-list__icon"/>
                </SearchResultItem>
            </SearchResultList>
        </SearchResult>
    </Search>);
export default Example;
